import axios from 'axios'

export const accountService = {
    get,
    update
}

async function update (id, account) {
    try {
        const response = await axios.put('/accounts/' + id, account)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}

async function get (id) {
    try {
        const response = await axios.get('/accounts/' + id)
        return Promise.resolve(response.data)
    } catch (error) {
        return Promise.reject(error)
    }
}
